<template>
	<UPagination
		v-model="page"
		:page-count="props.pageCount"
		:total="totalItems"
		:model-value="current"
		:max="5"
		:ui="{ rounded: 'rounded', wrapper: 'gap-2.5' }"
		:active-button="{
			color: 'primary',
			variant: 'link',
			class:
				'py-1 px-2.5 border border-primary-400 hover:bg-primary-400 hover:text-white hover:no-underline font-bold min-w-8 justify-center',
		}"
		:inactive-button="{
			color: 'primary',
			variant: 'link',
			class:
				'text-opacity-40 border border-white border-opacity-40 hover:bg-none py-1 px-2.5 hover:border-primary-400 hover:no-underline font-bold min-w-8 justify-center',
		}"
		@click="changePage(page)"
	>
		<template #prev="{ onClick, canGoPrev }">
			<UButton
				icon="i-ep:arrow-left-bold"
				color="white"
				:variant="`${!canGoPrev ? 'solid' : 'outline'}`"
				:ui="{
					rounded: 'rounded',
					icon: {
						size: 'sm',
					},
				}"
				:disabled="!canGoPrev"
				class="rtl:[&_span:first-child]:rotate-180 p-2 w-8 h-8 justify-center"
				:class="[
					!canGoPrev
						? 'bg-[#919EAB] opacity-50 ring-0 text-[#C4CDD5]'
						: 'text-white bg-transparent hover:bg-transparent',
				]"
				@click="onClick"
			/>
		</template>

		<template #next="{ onClick, canGoNext }">
			<UButton
				icon="i-ep:arrow-right-bold"
				color="white"
				:variant="`${!canGoNext ? 'solid' : 'outline'}`"
				:ui="{
					rounded: 'rounded',
					icon: {
						size: 'sm',
					},
				}"
				class="rtl:[&_span:last-child]:rotate-180 p-2 w-8 h-8 justify-center"
				:class="[
					!canGoNext
						? 'bg-[#919EAB] opacity-50 ring-0 text-[#C4CDD5]'
						: 'text-white bg-transparent hover:bg-transparent',
				]"
				:disabled="!canGoNext"
				@click="onClick"
			/>
		</template>
	</UPagination>
</template>

<script setup>
defineOptions({
	name: 'Pagination',
})

const props = defineProps({
	total: {
		type: Number,
		default: 1,
	},
	pageCount: {
		type: Number,
		default: 1,
	},
	current: {
		type: Number,
		default: 1,
	},
})
const emit = defineEmits(['change'])

const page = ref(1)

const totalItems = computed(() => {
	return props.total * props.pageCount
})

const changePage = (value) => {
	emit('change', value)
}
</script>
